import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledIconButton = styled(MuiButton)(({ theme, variant = 'contained', color = 'primary' }) => ({
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: theme.shape.borderRadius,
  transition: 'all 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
}));

const IconButton = ({
  children,
  icon,
  variant = 'contained',
  color = 'primary',
  size = 'small',
  disabled = false,
  onClick,
  iconPosition = 'start',
  ...props
}) => {
  const startIcon = iconPosition === 'start' ? icon : null;
  const endIcon = iconPosition === 'end' ? icon : null;

  return (
    <StyledIconButton
      variant={variant}
      color={color}
      size={size}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledIconButton>
  );
};

export default IconButton;
